import UserContext from 'Contexts/User';

import coinParliament, { functions } from '../../../firebaseCoinParliament';
import React, { useContext, useEffect, useState } from 'react'
import { Image } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import PAX from '../../../assets/logos/PAX.png';
import VTE from '../../../assets/logos/VTE.png';
import VCOIN from '../../../assets/logos/VCoin.png';
import { httpsCallable } from 'firebase/functions';
import axios from 'axios';
import styled from 'styled-components';
import { getVteValue, passNameAndGetData, transferVTE } from 'common/models/utils';
import WaitForResponse from 'Components/Waitforitloader/WaitForResponse';


const WalletCard = styled.div`
  background: white;
  border-radius: 5px;
  padding: 8px 18px;
  margin: 0.5rem 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TokenGroup = styled.div`
  display: flex;
  align-items: center;
  margin-left: 20px;
`;

const TokenImage = styled.img`
  width: 40px;
  height: 40px;
`;

const TokenLabel = styled.p`
  margin-left: 16px;
  color: black;
  margin-bottom: 0;
`;

const TokenAmount = styled.p`
  color: #6352E8;
  margin-bottom: 0;
  width: 100px;
  text-align: center;  
`;

const ButtonStyle = styled.button`
  width: 100px;
  padding: 5px;
  border: none;
  border-radius: 7px; 
  color:white;
  margin-top: 10px;
`;
const VteCountValue = styled.div`
  margin-left: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const SelectDiv = styled.select`
  width: 120px;
  padding: 8px;
  border: none;
  border-radius: 5px;
  // background-color: #f1f1f1;
  border:2px solid #f1f1f1;
  // margin-bottom: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;  
`;

const InputBox = styled.input`
  width: 120px;
  padding: 8px;
  border: none;
  border-radius: 5px;
  // background-color: #f1f1f1;
  border:2px solid #f1f1f1;
  
`;

const Logo = (symbol: any) => {
  return (
    <>

      {symbol && <Image
        src={process.env.PUBLIC_URL + `/images/logos/${symbol?.symbol?.toUpperCase()}.svg`}
        style={{
          // margin: "0 auto",
          width: `${symbol !== "ETH" ? "40px" : "35px"}`,
          height: `${symbol !== "ETH" ? "40px" : "40px"}`,
        }}
        onError={(e) =>
          ((e.target as HTMLImageElement).src = "/images/no_logo.png")
        }
      />}
    </>
  );
};

function ReceivedBalance({ ActiveProject }: { ActiveProject: any }) {

  const [pendingAmount, setPendingAmount] = useState({
    ETH: 0,
    BNB: 0,
    MATIC: 0,
    USDT: 0,
    VTE: 0,
  })
  const userIds = JSON.parse((localStorage.getItem('userId') || "{}"));
  let navigate = useNavigate();
  const { userInfo } = useContext(UserContext);
  const [modalShow, setModalShow] = React.useState(false);
  const handleClose = () => setModalShow(false);
  const [completedPAX, setCompletePax] = useState(0);
  const [errorValue, setErrorValue] = useState("");
  const [VTETransfer, setVTETransfer] = useState(false);
  const [VETValue, setVETValue] = useState(0);
  const [transferVteAmount, setTransferVteAmount] = useState("");
  const [isLoading, setIsLoading] = useState(false)
  const getCompletedPaxCountOfUserData = httpsCallable(functions, "getCompletedPaxCountOfUser");
  const [slectParliment, setSlectParliment] = useState("");
  const [allProjectName, setAllProjectName] = useState([
    { id: 0, name: "Select Parliament" },
    { id: 1, name: "Coin" },
    { id: 2, name: "Stock" },
    { id: 3, name: "Sport" },
    { id: 4, name: "Voting" },
    { id: 5, name: "Fun" },
    { id: 6, name: "Poker" },
    { id: 7, name: "Anime" },
  ]);
  const getCompletedPaxCountOfUser = async (ActiveProject: string) => {
    if (userInfo?.uid && ActiveProject == "Coin") {
      const data = {
        userId: userIds?.coin
      }
      axios.post(`${process.env.REACT_APP_COIN_API}/getCompletedPaxCountOfUser`, { data }).then((res) => {
        if (Object.keys(res?.data?.result?.result || {}).length) setCompletePax(res?.data?.result?.result || 0);
      }).catch((err) => {

      });
    } else {
      setCompletePax(0)
    }
  };

  // const getVteValue = async() => {
  //   const referUser = await coinParliament.firestore().collection('users').where('email', '==', userInfo?.email).get();
  //   if (!referUser.empty) {
  //     referUser.forEach((doc: any) => {        
  //       console.log(doc.data(), "doc.data()")

  //       setVETValue(doc.data()?.rewardStatistics?.rewardedVTE || 0)
  //     });
  //   }
  // }


  useEffect(() => {
    if (userInfo?.email) {
      getCompletedPaxCountOfUser(ActiveProject)
      getVteValue(ActiveProject, userInfo?.email, setVETValue)
    } else {
      setVETValue(0)
      setCompletePax(0)
    }
    setTransferVteAmount("")
    if (ActiveProject != "VoteToEran") {
      setSlectParliment("VoteToEran")
    } else {
      setSlectParliment("")
    }
  }, [userInfo?.uid, ActiveProject, userInfo?.rewardStatistics?.diamonds]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    setErrorValue("");
    // Regular expression to allow only positive decimal numbers greater than 0
    if (/^[1-9]\d*$/.test(inputValue) || inputValue === "") {
      setTransferVteAmount(inputValue);
      console.log(inputValue, "inputValueinputValue")
    }
  };
  const TransforVteToOther = async () => {
    if (!slectParliment || slectParliment == "Select Parliament") {
      setErrorValue("Please select parliament");
      return;
    }
    if (!transferVteAmount) {
      setErrorValue("Please enter VTE coin");
      return;
    }
    if (Number(transferVteAmount) > Number(VETValue)) {
      setErrorValue("You don't have enough VTE coin");
      return;
    }
    setIsLoading(true);
    setErrorValue("");
    const foundItem = await passNameAndGetData(ActiveProject)
    const baseData = {
      userId: `${foundItem?.userId}`,
      email: `${userInfo?.email}`,
      VTEAmount: Number(transferVteAmount),
    }
    const apiUrls: Record<string, string | undefined> = {
      "Coin": process.env.REACT_APP_COIN_API + "transferVTEToVoteToEarn",
      "Stock": process.env.REACT_APP_STOCK_API + "transferVTEToVoteToEarn",
      "Sport": process.env.REACT_APP_SPORT_API + "transferVTEToVoteToEarn",
      "Voting": process.env.REACT_APP_VOTING_API + "transferVTEToVoteToEarn",
      "Fun": process.env.REACT_APP_FUN_API + "transferVTEToVoteToEarn",
      "Poker": process.env.REACT_APP_POKER_API + "transferVTEToVoteToEarn",
      "Anime": process.env.REACT_APP_ANIME_API + "transferVTEToVoteToEarn",
      "VoteToEarn": process.env.REACT_APP_V2E + "transferVTEToGivenParliament",
    };

    if (ActiveProject === "VoteToEarn") {
      const voteToEarnItem = await passNameAndGetData(slectParliment);
      if (!voteToEarnItem) return;

      const voteToEarnData = {
        userId: `${userInfo?.uid}`,
        email: `${userInfo?.email}`,
        VTEAmount: Number(transferVteAmount),
        parliament: voteToEarnItem?.id,
      };

      transferVTE(apiUrls[ActiveProject]!, voteToEarnData, setVTETransfer, setIsLoading);
    } else {
      transferVTE(apiUrls[ActiveProject]!, baseData, setVTETransfer, setIsLoading);
    }
  }

  console.log(slectParliment, "setSlectParliment")
  return (
    <div>
      <>
        {isLoading && <>
          <WaitForResponse />
        </>}
        <div className='d-flex justify-content-center align-items-center'
          style={{
            // color: "white"
          }}
        >
          <div className='mt-3'>
            <p className='mx-3 text-center' style={{
              fontSize: "16px",
              color: "white"
            }}>{"YOUR REWARD RECEIVE AMOUNT".toLocaleUpperCase()}</p>
            <WalletCard>
              <TokenGroup>
                <TokenImage src={PAX} alt="PAX" />
                <TokenLabel>PAX</TokenLabel>
              </TokenGroup>
              <TokenAmount>{completedPAX}</TokenAmount>
            </WalletCard>

            <WalletCard>
              <TokenGroup>
                <TokenImage src={VCOIN} alt="Vcoin" />
                <TokenLabel>Vcoin</TokenLabel>
              </TokenGroup>
              <TokenAmount>{(userInfo?.vCoin)?.toLocaleString() || 0}</TokenAmount>
            </WalletCard>

            {!VTETransfer && (
              <WalletCard>
                <TokenGroup>
                  <TokenImage src={VTE} alt="VTE" />
                  <TokenLabel>VTE</TokenLabel>
                </TokenGroup>
                <TokenAmount>{VETValue}</TokenAmount>
              </WalletCard>
            )}
            {VTETransfer && <div className='my-2'
              style={{
                background: "white",
                borderRadius: "5px",
                padding: "15px 0px",
              }}
            >
              <div className='d-flex justify-content-around align-items-center my-2'>
                <VteCountValue className=''>
                  <p className=''
                    style={{
                      color: "black",
                    }}
                  >VTE</p>
                  <p className=''
                    style={{
                      color: "#6352E8",
                    }}
                  >{VETValue}</p>
                </VteCountValue>
                <InputBox type='text' placeholder='Enter VTE coin' value={transferVteAmount} onChange={handleChange} />
                {ActiveProject == "VoteToEarn" ? <SelectDiv
                  value={slectParliment}
                  onChange={(e) => {
                    setSlectParliment(e.target.value)
                    setErrorValue("")
                  }}
                >
                  {allProjectName?.map((projectName) => {
                    return (<option key={projectName.id}
                      // onClick={() => {
                      //     setActiveProject(projectName.name)
                      // }}
                      value={projectName?.name}
                    >
                      {projectName?.name}
                    </option>)
                  })}
                </SelectDiv>
                  :
                  // <SelectDiv
                  //     value={slectParliment}
                  //     onChange={(e) => {
                  //       setSlectParliment(e.target.value)
                  //       setErrorValue("")
                  //     }}
                  // >                          
                  //         <option key={0} value={"Select Parliament"}>
                  //             {"Select Parliament"}
                  //         </option>                          
                  //         <option key={1} value={"VoteToEran Parliament"}>
                  //             {"VoteToEran Parliament"}
                  //         </option>                          
                  // </SelectDiv>  
                  <InputBox type='text' value={"VoteToEran"} disabled
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis"
                    }}
                  />
                }
              </div>
              <p className="text-center" style={{ color: "red" }}>{errorValue}</p>
            </div>}
            {
              !VTETransfer &&
              <div className='d-flex justify-content-center'>
                <ButtonStyle
                  style={{
                    background: "#6352e8"
                  }}
                  onClick={() => {
                    setVTETransfer(true)
                  }}
                >Transfer VTE</ButtonStyle>
              </div>
            }
            {
              VTETransfer &&
              <div className='d-flex justify-content-around'>
                <ButtonStyle
                  style={{
                    background: "#6352e8"
                  }}
                  onClick={() => {
                    TransforVteToOther()
                  }}
                >Transfer VTE</ButtonStyle>
                <ButtonStyle
                  style={{
                    background: "#f1f1f1",
                    color: "Black"
                  }}
                  onClick={() => {
                    setVTETransfer(false)
                    setSlectParliment("")
                    setTransferVteAmount("")
                    setErrorValue("")
                  }}
                >Cancel</ButtonStyle>
              </div>
            }
            {!userInfo?.uid?.includes("telegram") && <p className='mx-3' style={{
              fontSize: "18px",
              margin: "20px 0px 10px 0px",
              color: "white"
            }}>{"Your Referral Receive Amount".toLocaleUpperCase()}</p>}

            {!userInfo?.uid?.includes("telegram") && Object?.keys(pendingAmount)?.length ?
              <div className='d-flex flex-column'>
                {Object?.keys(pendingAmount)?.map((value, index) => {
                  if (value == "ETH" || value == "BNB" || value == "MATIC" || value == "USDT") {
                    return <>

                      <WalletCard>
                        <TokenGroup>
                          {/* <TokenImage src={PAX} alt="PAX" /> */}
                          <Logo
                            symbol={value}

                          />
                          <TokenLabel>{value == "MATIC" ? "POL" : value}</TokenLabel>
                        </TokenGroup>
                        <TokenAmount>{pendingAmount[value] != 0 ? Number(pendingAmount[value])?.toFixed(4) : 0}</TokenAmount>
                      </WalletCard>
                    </>
                  }

                })
                }

              </div>
              :
              <div className="d-flex justify-content-center" >
                <p className='mt-3'>Pending Payment Amount is not found</p>
              </div>
            }
          </div>
        </div>
      </>
    </div>
  )
}

export default ReceivedBalance